import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { VerifyToken } from '../../api/auth'; // This should return { success, token, data }
import { AuthContext } from '../../context/AuthContextProvider';

const OnboardingToken = () => {
  const [status, setStatus] = useState('loading');
  const { id } = useParams();
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const checkTokenFromUrl = async () => {
      if (!id) {
        setStatus('error');
        return;
      }
      try {
        const response = await VerifyToken({ id });

      
        if (response.success === true) {
          login(response.data, response.token);
          setStatus('success');

          setTimeout(() => {
            navigate('/onboarding/1');
          }, 500);
        } else {
          setStatus('error');
        }
      } catch (err) {
        console.error('Error verifying token:', err);
        setStatus('error');
      }
    };

    checkTokenFromUrl();
  }, [id]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      {status === 'loading' && <h6>Verifying token...</h6>}
      {status === 'success' && <h6>Token verified. Redirecting...</h6>}
      {status === 'error' && <h6>Verification failed. Invalid or expired link.</h6>}
    </div>
  );
};

export default OnboardingToken;
